import $ from 'jquery';
import Foundation from 'foundation-sites';

import select2 from 'select2/dist/js/select2.full';

import Util from './../utils';

// https://github.com/foundation/foundation-sites/issues/10363
//Foundation.MediaQuery._init();
// $(function () {
//     console.log('**** FYH Filters JS - DOM READY');
//     FindYourHomeFilters.initFilters();
// });

var CommunitySearchFilters = {
    _moreFiltersBtnText: "",
    _filterCount: 0,
    _formData: null,
    _entryItem: null,
    _entryVal: null,
    // FILTER FORM
    _filterFormSelector: ".home-search-form",
    _filterForms: document.querySelectorAll(".home-search-form"),
    // APPLY FILTERS BUTTON
    _applyFiltersBtnSelector: ".home-search-apply-filters",
    _applyFiltersButtons: document.querySelectorAll(".home-search-apply-filters"),
    _applyFiltersButtonClickHandler: null,
    _offCanvasElem: document.getElementById('filtersOffCanvas'),
    _fyhFiltersModifiedFlag: true,
    IS_LOCALHOST: location.host.indexOf("localhost") >= 0,

    /**
     * ==================================
     *  Hidden State and Region Filters
     * ==================================
     */
    _hdfStateFilters: $("[name=state]"),
    _hdfRegionFilters: $("[name=region"),


    _resetFiltersBtn: document.querySelectorAll('.home-search-form-reset'),


    /**
     * Init function to initialize all components within the FYH Off Canvas Filters
     *
     * NOTE: Needs to be called after DOM READY so that foundation is executed by the time this function executes
     */
    initFilters: function(){
        const _THIS = this;
        Foundation.MediaQuery._init();

        CommunitySearchFilters.handleBreakpointChange();

        CommunitySearchFilters._applyFiltersButtons && CommunitySearchFilters._applyFiltersButtons.forEach((button) => button.addEventListener("click", CommunitySearchFilters.applyFilters));

        // reinit foundation on off canvas
        //Foundation.reInit(test);

        // Make sure to retain sort dropdown value when clicking reset filter in FYH Page
        // $("#reset-additional-filters").click(function (e) {
        //     e.preventDefault();
        //     var currentSortValue = $("#sort-dropdown").val();
        //     var form = _THIS._filterFormElem;
        //     form.reset();
        //     $("#sort-dropdown").val(currentSortValue);
        // });

        
        

        // Init reset map handler
        $(_THIS._resetFiltersBtn).click(function (event) {
            var dropdowns = $(".home-search-form-field .shea-custom-dropdown-singleselect");
            dropdowns.each(function (index, dropdown) {
                // The placeholder option has a value of any
                $(dropdown).select2("val", "any", false);
            });

            dropdowns = $(".home-search-form-field .shea-custom-dropdown-multiselect");
            dropdowns.each(function (index, dropdown) {
                // Trigger reset of multi selects
                $(dropdown).select2("val", "any", false);
            });

            // Reset the checkboxes
            $('.home-search-form-field input[type=checkbox]').prop('checked', false);

            // Trigger a search now that filters have been reset
            //CommunitySearchFilters._applyFiltersButtons.click();

            // Trigger click for the appropiate submit button (appropiate being 
            // fetching the desktop apply if this is the desktop form, else get the
            // mobile one)
            // )
            let resetButtonElem = $(event.target);
            let applyFiltersButton = $(resetButtonElem.parents(CommunitySearchFilters._filterFormSelector).find(_THIS._applyFiltersBtnSelector));
            applyFiltersButton.trigger("click");
        });

        // Set filter values based on url params
        var urlParams = Util.getUrlParameters();
        if (urlParams.length > 0) {
            CommunitySearchFilters._filterCount = 0;
            $.each(urlParams, function (key, value) {
                var control = $("input[name='" + key + "']");
                if (control.length == 0) {
                    control = $("select[name='" + key + "']");
                }
                
                let controlArray = control.length === undefined ? [control] : control;
                controlArray.each(function (index, control) {
                    var control = $(control); // Ensure control is a jQuery object
                    if (control.is(':checkbox')) {
                        if (value == "on") {
                            control.prop('checked', true);
                        }
                    } else {
                        let values = Array.isArray(value) ? value : [value];
                        values = values.map(function (val) {
                            return decodeURIComponent(val);
                        });
                        if (control.is('select.shea-custom-dropdown-multiselect')) {
                            setTimeout(function () {
                                control.val(values).change();
                            }, 1000);

                        } else {
                            control.val(values).change();
                        }
                    }
                });

                if (value != "state" && value != "region" && urlParams[value] != "any" && (urlParams[value] > 0 || urlParams[value] == "on")) {
                    CommunitySearchFilters._filterCount += 1;
                }
            });
            if (CommunitySearchFilters._filterCount > 0) {                
                let formWrapper = $(CommunitySearchFilters._filterForms);
                CommunitySearchFilters.setCommunitySearchFiltersJson(formWrapper);                
            }
        }  

        window.initCustomDropdowns($(".home-search-form-dropdown.shea-custom-dropdown-singleselect"), false, true);
        window.initCustomDropdowns($(".home-search-form-dropdown.shea-custom-dropdown-multiselect"), true, true);
        
        // update filter button when breakpoint changes
        $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
            CommunitySearchFilters.handleBreakpointChange();
            CommunitySearchFilters._applyFiltersButtons && CommunitySearchFilters._applyFiltersButtons.forEach((button) => button.addEventListener("click", CommunitySearchFilters.applyFilters));
        });

        /**
         * Set the event handlers for the state-region popup that contains
         * state to region drilldown links
         */
        // Desktop State Filter
        $(".fyh-state-filter").click(function () {
            // Populate the hidden inputs that record the selected state and region
            _THIS._hdfStateFilters.val($(this).data("state-filter"));
            _THIS._hdfRegionFilters.val($(this).data("regions-filter"));
            
            let modal = $("#fyh-tab-modal");
            if ($(modal).hasClass("reveal") === true) {                
                window.foundationWrapper( $(modal), 'close');
            }
            let stateName = $(this).data("state-name");            

            // initiate another search by dynamically clicking the apply filters button
            _THIS._applyFiltersButtons.click();
        });

        // Desktop Region Filter
        $(".fyh-region-filter").click(function () {
            // Populate the hidden inputs that record the selected state and region
            _THIS._hdfStateFilters.val($(this).data("state-filter"));
            _THIS._hdfRegionFilters.val($(this).data("region-filter"));
            let modal = $("#fyh-tab-modal");
            
            if ($(modal).hasClass("reveal") === true) {                
                window.foundationWrapper( $(modal), 'close');
            }
            let stateName = $(this).data("state-name");
            let regionName = $(this).data("region-name");            

            // initiate another search by dynamically clicking the apply filters button
            _THIS._applyFiltersButtons.click();
        });

        // Mobile State Filter
        $(".fyh-state-filter-mobile").click(function (event) {
            if ($("#hfFYHStateRegionFilterWasClicked").length > 0 && $("#hfFYHStateRegionFilterWasClicked").val() == "true") {
                event.preventDefault();
                // Reset this flag to false.
                $("#hfFYHStateRegionFilterWasClicked").val("false");
                // Populate the hidden inputs that record the selected state and region
                _THIS._hdfStateFilters.val($(this).data("state-filter"));
                _THIS._hdfRegionFilters.val($(this).data("regions-filter"));
                
                let modal = $("#fyh-modal");
                if ($(modal).hasClass("reveal") === true) {                    
                    window.foundationWrapper( $(modal), 'close');
                }
                let stateName = $(this).data("state-name");                

                // initiate another search by dynamically clicking the apply filters button
                _THIS._applyFiltersButtons.click();

            }
            else {
                window.location = "/new-homes/?state=" + $(this).data("state-filter") + "&region=any&bedrooms=0&bathrooms=0&pricemin=any&pricemax=any";
            }
        });

        // Mobile Region Filter
        $(".fyh-region-filter-mobile").click(function (event) {
            if ($("#hfFYHStateRegionFilterWasClicked").length > 0 && $("#hfFYHStateRegionFilterWasClicked").val() == "true") {
                // Reset this flag to false.
                $("#hfFYHStateRegionFilterWasClicked").val("false");
                event.preventDefault();
                // Populate the hidden inputs that record the selected state and region
                _THIS._hdfStateFilters.val($(this).data("state-filter"));
                _THIS._hdfRegionFilters.val($(this).data("region-filter"));
                let modal = $("#fyh-modal");
                
                if ($(modal).hasClass("reveal") === true) {                    
                    window.foundationWrapper( $(modal), 'close');
                }
                let stateName = $(this).data("state-name");
                let regionName = $(this).data("region-name");                

                // initiate another search by dynamically clicking the apply filters button
                _THIS._applyFiltersButtons.click();

            }
            else {
                window.location = "/new-homes/?state=" + $(this).data("state-filter") + "&region=" + $(this).data("region-filter") + "&bedrooms=0&bathrooms=0&pricemin=any&pricemax=any";
            }
        });     
    },

    /**
     * Check current breakpoint and grab correct
     * apply filters button
     *
     * @return {void} Nothing
     */
    handleBreakpointChange: function() {
        if (Foundation.MediaQuery.atLeast("medium")) {
            CommunitySearchFilters._opensOffCanvasBtn = document.getElementById('desktop-filters');
            CommunitySearchFilters._moreFiltersBtnText = "More Filters";
        } 
        else {
            CommunitySearchFilters._opensOffCanvasBtn = document.getElementById('mobile-filters');
            CommunitySearchFilters._moreFiltersBtnText = "Filters";
        }
    },

    /**
     *
     * @param {Function} func function accept an object parameter containing the
     * mapping of form field names and their values. Function is invoked at the end of APPLY FILTERS
     * button click after form data has been processed
     */
    setOnApplyFiltersClickHandler(func) {
        CommunitySearchFilters._applyFiltersButtonClickHandler = func;
    },

    /**
     * Get the selected values from each dropdown (make sure we are retrieving values from the correct
     * fields e.g., mobile form or desktop form) and build the JSON string used to pass to the BE
     *
     * @param {elem} elem DOM element that is triggering this even
     * @param {boolean} resetSortToDefault True to reset the sort dropdown back to its default sort order for next query
     */
    applyFilters(event, elem, resetSortToDefault) {
        event.preventDefault();

        // Get the selected values from each dropdown (make sure we are retrieving values from the correct
        // fields e.g., mobile form or desktop form)
        let applyFilterButton = $(event.currentTarget);

        // Reference the form containing the apply button that was triggered
        let formWrapper = $(applyFilterButton.parents(CommunitySearchFilters._filterFormSelector));

        // If specified, set the value of the sort to the default sort alpha_a-z
        if (resetSortToDefault === true) {
            $(".region-community-cards select[name=sort]").val("alpha_a-z").trigger("select2:select");
        }
        // Save the sort after reseting the sort dropdown
        CommunitySearchFilters.setCommunitySearchFiltersJson(formWrapper);

        CommunitySearchFilters.updateUrl(formWrapper);

        // grab all inputs with values set everytime user clicks apply filters
        //CommunitySearchFilters._formData = $(CommunitySearchFilters._filterFormElem).find("select, input[type=range], input[type=checkbox]").serializeArray();

        // Close the reveal modal if form wrapper is a reveal modal
        if ($(formWrapper).hasClass("reveal") === true) {
            $(formWrapper).foundation("close");
        }

        // pass form data into apply filters click handler
        if(CommunitySearchFilters._applyFiltersButtonClickHandler != null) {
            CommunitySearchFilters._applyFiltersButtonClickHandler(CommunitySearchFilters._formData);
        }
    },

    /**
     * 
     * @param {jQuery Object} formWrapperElem DOM element that is triggering this event
     */
    setCommunitySearchFiltersJson(formWrapperElem) {
        // Get the selected values from each dropdown (make sure we are retrieving values from the correct
        // fields e.g., mobile form or desktop form)
        let formWrapper = $(formWrapperElem);
        let dropdowns = formWrapper.find("select");
        let textFields = formWrapper.find("input[type=range]");
        let checkboxes = formWrapper.find("input[type=checkbox]");
        let hiddenFields = formWrapper.find("input[type=hidden]:not(#hiddenHomeSearchFormData)");
        let filterValues = {};
        dropdowns.each(function (index, elem) {
            // Grab dropdown and the name
            let dropdown = $(elem);
            // Add values to filterValues object indexed by the dropdown name
            filterValues[dropdown.attr("name")] = dropdown.val();
        });
        // grab the checkbox values
        checkboxes.each(function (index, value) {
            let isChecked = $(this).is(":checked");
            // <name> and <name>-mobile are just for desktop and mobile names respectively.
            // For consistency, strip out the name portion and use that for the JSON field name
            let checkboxName = $(this).attr("name");
            if (checkboxName.indexOf("-") >= 0) {
                checkboxName = checkboxName.substring(0, checkboxName.indexOf("-"));
            }
            filterValues[checkboxName] = isChecked;
        });
        // grab the textbox values
        textFields.each(function (index, elem) {
            let textField = $(elem);
            let textFieldName = textField.attr("name");
            if (textFieldName.indexOf("-") >= 0) {
                textFieldName = textFieldName.substring(0, textFieldName.indexOf("-"));
            }
            // Add values to filterValues object indexed by the dropdown name
            filterValues[textFieldName] = textField.val();
        });

        // grab the hiddenfield values
        hiddenFields.each(function (index, elem) {
            let hiddenField = $(elem);
            let hiddenFieldName = hiddenField.attr("name");
            if (hiddenFieldName.indexOf("-") >= 0) {
                hiddenFieldName = hiddenFieldName.substring(0, hiddenFieldName.indexOf("-"));
            }
            // Add values to filterValues object indexed by the dropdown name
            filterValues[hiddenFieldName] = hiddenField.val();
        });

        // Attempt to get the sort dropdown (only on Region pages)
        let sortDropdown = $(".region-community-cards select[name=sort]");
        if( sortDropdown != null && sortDropdown.length > 0) {
            // Grab all of the selected values for this dropdown
            let dropdownValues = sortDropdown.select2("data");
            let values = [];
            dropdownValues.forEach(function (value) {
                values.push(value.id);
            })

            // Add values to filterValues object indexed by the dropdown name
            filterValues["sort"] = values;
        }

        // Place JSON Data within the hidden textbox
        let hiddenTextBox = $("#hiddenHomeSearchFormFilterValues");
        let jsonFilters = JSON.stringify(filterValues);
        $(hiddenTextBox).val(filterValues);

        CommunitySearchFilters._formData = filterValues;
    },
    /**
     * Updates the browser url and history state to reflect the current state of the filters
     * 
     * It will also make sure to update the sign in link of all favorite buttons on the page so that users
     * are redirected to the current state of FYH after logging in to favorite a community
     * 
     * @param {jqueryElement} formWrapperElem jQuery element pointing to the form wrapper containing the filters we want to serialize into the URL query parameters
     */
    updateUrl(formWrapperElem) {
        // Update the browser history with selected filters as query parameters
        const PORT_STRING = window.location.port ? (":" + window.location.port) : "";
        let redirectUrl = window.location.protocol + "//" + window.location.hostname + PORT_STRING + window.location.pathname;

        // serialize the form data to pass to redirect page
        let formData = $(formWrapperElem).find("select, input[type=range], input[type=checkbox], input[type=hidden]").serialize();
        let newUrl = redirectUrl + "?" + formData;

        window.history.replaceState(formData, document.title, newUrl);

        // Also update the signin-modal sign in url...this ensures the filters are restored after an attempted signin
        let urlEncodedReturnUrl = encodeURIComponent(window.location.pathname + "?" + formData);
        $("#" + window.SIGNIN_MODAL_ID + " .signin-link").prop("href", "" + window.MSH_SITE_URL + "acct/signin/?returnurl=" + urlEncodedReturnUrl);
    }

};

export default CommunitySearchFilters;



